import {useAuth} from 'app/modules/auth'
import {Role} from 'app/shared/Common/Enums'
import { HasPermissionInRole } from 'app/shared/Common/Util'
import React, {FC, useEffect, useState} from 'react'
import {Button} from 'react-bootstrap'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const Error401: FC = () => {
  const {currentUser} = useAuth()

  const [MainPage, setMainPage] = useState<'Dashboard' | 'Home Page'>('Dashboard')

  useEffect(() => {
    if (HasPermissionInRole(currentUser, [Role.INT_Report_Full, Role.INT_Report_Read])) {
      setMainPage('Dashboard')
    } else {
      setMainPage('Home Page')
    }
  }, [currentUser])

  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid p-10 text-center'>
        <img src={toAbsoluteUrl('/media/logos/logo_reversed.svg')} alt='' className='mw-100 mb-20 h-100px' />

        <h1 className='fw-bolder fs-2qx mb-10'>Unauthorized</h1>
        <div className='fw-bold fs-2 text-muted'>
          Sorry! You have not been authorized to access this.
          <br />
          Please go back to {MainPage}.
        </div>

        <Button variant='primary' className='mt-5' href='/'>
          Go {MainPage}
        </Button>
      </div>
    </div>
  )
}

export {Error401}
